// F2W product card — option + ATC handlers
(function () {
  if (document.documentElement.dataset.f2wAtcBound) return;
  document.documentElement.dataset.f2wAtcBound = '1';

  function f2wFormatPrice(cents) {
    if (window.Shopify && Shopify.formatMoney && window.f2w_money_format) {
      return Shopify.formatMoney(cents, window.f2w_money_format);
    }
    return (cents / 100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  // Option button (size selector)
  document.addEventListener('click', function (e) {
    var optBtn = e.target.closest('.f2w-option-btn');
    if (!optBtn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var variantId = optBtn.dataset.variantId;
    var group = optBtn.closest('.f2w-option-group');
    if (group) {
      group.querySelectorAll('.f2w-option-btn').forEach(function (b) {
        b.removeAttribute('aria-selected');
        b.classList.remove('is-selected');
      });
      optBtn.setAttribute('aria-selected', 'true');
      optBtn.classList.add('is-selected');
    }
    var wrapper = optBtn.closest('.f2w-atc-wrapper');
    if (wrapper) {
      var atcBtn = wrapper.querySelector('.f2w-atc-btn');
      if (atcBtn && variantId) {
        atcBtn.dataset.variantId = variantId;
        atcBtn.disabled = optBtn.classList.contains('is-unavailable');
      }
      var card = wrapper.closest('product-card');
      if (card) {
        var variantsJson = card.querySelector('.f2w-variants-json');
        if (variantsJson) {
          try {
            var variants = JSON.parse(variantsJson.textContent);
            var variant = variants.find(function (v) { return String(v.id) === String(variantId); });
            if (variant && variant.price !== undefined) {
              var priceEl = card.querySelector('.price ins .amount') || card.querySelector('.price .amount');
              if (priceEl) priceEl.textContent = f2wFormatPrice(variant.price);
            }
          } catch (err) {
            console.warn('F2W price update error:', err);
          }
        }
      }
    }
  }, true);

  // ATC button
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.f2w-atc-btn[data-variant-id]');
    if (!btn || btn.disabled || btn.classList.contains('loading')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var variantId = btn.dataset.variantId;
    if (!variantId) return;
    btn.classList.add('loading');
    btn.disabled = true;
    var resetTimer = setTimeout(function () {
      btn.classList.remove('loading');
      btn.disabled = false;
    }, 5000);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Cart add failed: ' + r.status);
      return r.json();
    })
    .then(function () {
      clearTimeout(resetTimer);
      btn.classList.remove('loading');
      btn.disabled = false;
      setTimeout(function () {
        if (window.opusRefresh) window.opusRefresh();
        if (window.opusOpen) {
          window.opusOpen();
        } else {
          document.documentElement.dispatchEvent(
            new CustomEvent('cart-drawer:open', { bubbles: true })
          );
        }
      }, 150);
    })
    .catch(function (err) {
      clearTimeout(resetTimer);
      console.error('F2W ATC error:', err);
      btn.classList.remove('loading');
      btn.disabled = false;
    });
  }, true);

  // ── Init: correct price on load for pre-selected variant ─────────────────
  function initF2wCards() {
    document.querySelectorAll('.f2w-atc-wrapper').forEach(function (wrapper) {
      var selected = wrapper.querySelector('.f2w-option-btn.is-selected')
                  || wrapper.querySelector('.f2w-option-btn:not(.is-unavailable)');
      if (!selected) return;

      var variantId = parseInt(selected.dataset.variantId, 10);
      var jsonEl = wrapper.querySelector('.f2w-variants-json');
      if (!jsonEl) return;

      try {
        var variants = JSON.parse(jsonEl.textContent);
        var variant = variants.find(function (v) { return v.id === variantId; });
        if (!variant || variant.price === undefined) return;

        var card = wrapper.closest('product-card');
        var priceEl = card && (card.querySelector('.price ins .amount') || card.querySelector('.price .amount'));
        if (!priceEl) return;

        priceEl.textContent = f2wFormatPrice(variant.price);
      } catch (err) {
        console.warn('F2W init price error:', err);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initF2wCards();
      setTimeout(initF2wCards, 500);
    });
  } else {
    initF2wCards();
    setTimeout(initF2wCards, 500);
  }

})();

// CPG (custom product grid) — option + ATC handlers
(function () {
  if (!document.documentElement.dataset.cpgOptionBound) {
    document.documentElement.dataset.cpgOptionBound = 'true';
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.cib__variant-btn');
      if (!btn) return;
      var card = btn.closest('.custom-product-grid__card');
      if (!card) return;
      card.querySelectorAll('.cib__variant-btn').forEach(function (b) { b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      var atcBtn = card.querySelector('.cib__atc-btn');
      if (atcBtn) atcBtn.dataset.variantId = btn.dataset.variantId;
      var priceEl = card.querySelector('.custom-product-grid__price');
      if (priceEl && btn.dataset.variantId) {
        fetch('/variants/' + btn.dataset.variantId + '.js')
          .then(function (r) { return r.json(); })
          .then(function (v) {
            if (v.price !== undefined) {
              priceEl.innerHTML = window.Shopify && Shopify.formatMoney && window.f2w_money_format
                ? Shopify.formatMoney(v.price, window.f2w_money_format)
                : (v.price / 100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }
          });
      }
    });
  }

  if (!document.documentElement.dataset.cpgAtcBound) {
    document.documentElement.dataset.cpgAtcBound = 'true';
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.cib__atc-btn');
      if (!btn || !btn.dataset.variantId) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var variantId = btn.dataset.variantId;
      var originalText = btn.textContent.trim();
      btn.disabled = true;
      btn.textContent = '...';
      var resetTimer = setTimeout(function () { btn.disabled = false; btn.textContent = originalText; }, 5000);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: 1 }] })
      })
      .then(function (res) { return res.json(); })
      .then(function () {
        clearTimeout(resetTimer);
        btn.disabled = false;
        btn.textContent = originalText;
        setTimeout(function () {
          if (window.opusRefresh) window.opusRefresh();
          if (window.opusOpen) window.opusOpen();
          else document.documentElement.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
        }, 150);
      })
      .catch(function () { clearTimeout(resetTimer); btn.disabled = false; btn.textContent = originalText; });
    }, true);
  }
})();

// CIB (collection-info / faq-item / gear-type-info) — option + ATC + price handlers
(function () {
  if (document.documentElement.dataset.cibOptionBound) return;
  document.documentElement.dataset.cibOptionBound = '1';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cib__variant-btn');
    if (!btn) return;
    var card = btn.closest('.cib__ref-card');
    if (!card) return;
    card.querySelectorAll('.cib__variant-btn').forEach(function (b) { b.classList.remove('is-selected'); });
    btn.classList.add('is-selected');
    var atcBtn = card.querySelector('.cib__atc-btn');
    if (atcBtn) atcBtn.dataset.variantId = btn.dataset.variantId;
    var priceEl = card.querySelector('.cib__ref-card__price');
    if (priceEl && btn.dataset.variantId) {
      fetch('/variants/' + btn.dataset.variantId + '.js')
        .then(function (r) { return r.json(); })
        .then(function (v) {
          if (v.price !== undefined) {
            priceEl.innerHTML = window.Shopify && Shopify.formatMoney && window.f2w_money_format
              ? Shopify.formatMoney(v.price, window.f2w_money_format)
              : (v.price / 100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          }
        });
    }
  });

  if (!document.documentElement.dataset.cibAtcBound) {
    document.documentElement.dataset.cibAtcBound = '1';
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.cib__atc-btn[data-variant-id]');
      if (!btn || btn.disabled || btn.tagName === 'A') return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var variantId = btn.dataset.variantId;
      if (!variantId) return;
      var originalText = btn.textContent.trim();
      btn.disabled = true;
      btn.textContent = '...';
      var resetTimer = setTimeout(function () { btn.disabled = false; btn.textContent = originalText; }, 5000);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        clearTimeout(resetTimer);
        btn.disabled = false;
        btn.textContent = originalText;
        setTimeout(function () {
          if (window.opusRefresh) window.opusRefresh();
          if (window.opusOpen) window.opusOpen();
          else document.documentElement.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
        }, 150);
      })
      .catch(function () { clearTimeout(resetTimer); btn.disabled = false; btn.textContent = originalText; });
    }, true);
  }
})();

/* ------------------------------------------------------------------
   F2W slider arrows - one implementation for every slider.

   Replaces five near-identical blocks (CIB, beste-koop nav, gallery,
   brand/scb, custom-product-grid). Behaviour is now identical
   everywhere: arrows hide at each end, hide completely when the track
   does not overflow, and re-evaluate on scroll, resize and image load.

   New markup should use the data attributes:
     <div data-slider-wrapper
          data-slider-track=".my-track"
          data-slider-card=".my-card"
          data-slider-step="3">

   The class pairs below keep every existing slider working unchanged.
------------------------------------------------------------------ */
(function () {
  var EDGE = 4;

  var LEGACY = [
    {
      wrapper: '.cib__slider-wrapper',
      track: '.cib__ref-cards--slider',
      card: '.cib__ref-card',
      prev: '.f2w-arrow--prev',
      next: '.f2w-arrow--next',
      gap: 10,
      fallback: 200,
      step: 3
    },
    {
      wrapper: '.f2w-article-nav-slider',
      track: '.f2w-blog-slider__track',
      card: '.f2w-blog-slider__card',
      prev: '.f2w-arrow--prev',
      next: '.f2w-arrow--next',
      gap: 12,
      fallback: 220,
      step: 2
    },
    {
      wrapper: '.f2w-gallery__slider-wrap',
      track: '.f2w-gallery__list',
      card: '.f2w-gallery__item',
      prev: '.custom-product-grid__arrow--prev',
      next: '.custom-product-grid__arrow--next',
      gap: 12,
      fallback: 260,
      step: 2
    },
    {
      wrapper: '.f2w-blog-slider__wrapper',
      track: '.scb-slider__track',
      card: '.scb-card',
      prev: '.f2w-arrow--prev',
      next: '.f2w-arrow--next',
      gap: 10,
      fallback: 170,
      step: 1
    },
    {
      wrapper: '.custom-product-grid__slider-wrap',
      track: '.custom-product-grid__list',
      card: '.custom-product-grid__item',
      prev: '.custom-product-grid__arrow--prev',
      next: '.custom-product-grid__arrow--next',
      gap: 10,
      fallback: 200,
      step: 3
    }
  ];

  function initSlider(wrapper, config) {
    if (!wrapper || wrapper.dataset.f2wSliderReady === 'true') return;

    var track = wrapper.querySelector(config.track);
    var prev = wrapper.querySelector(config.prev);
    var next = wrapper.querySelector(config.next);

    if (!track || !prev || !next) return;

    wrapper.dataset.f2wSliderReady = 'true';

    function cardWidth() {
      var card = config.card ? track.querySelector(config.card) : null;
      return card ? card.offsetWidth + config.gap : config.fallback;
    }

    function updateArrows() {
      var noScroll = track.scrollWidth <= track.clientWidth + EDGE;
      var atStart = noScroll || track.scrollLeft <= EDGE;
      var atEnd = noScroll || track.scrollLeft + track.clientWidth >= track.scrollWidth - EDGE;

      prev.classList.toggle('f2w-arrow--hidden', atStart);
      next.classList.toggle('f2w-arrow--hidden', atEnd);

      prev.disabled = atStart;
      next.disabled = atEnd;
    }

    function scrollByCards(direction) {
      track.scrollBy({ left: direction * cardWidth() * config.step, behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { scrollByCards(-1); });
    next.addEventListener('click', function () { scrollByCards(1); });
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(updateArrows).observe(track);
    }

    track.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', updateArrows, { once: true });
    });

    updateArrows();
  }

  function initAll(root) {
    var scope = root || document;

    // Explicit slider settings take priority over matching legacy classes.
    scope.querySelectorAll('[data-slider-wrapper]').forEach(function (wrapper) {
      initSlider(wrapper, {
        track: wrapper.dataset.sliderTrack || '[data-slider-track]',
        card: wrapper.dataset.sliderCard || null,
        prev: wrapper.dataset.sliderPrev || '.f2w-arrow--prev',
        next: wrapper.dataset.sliderNext || '.f2w-arrow--next',
        gap: parseInt(wrapper.dataset.sliderGap, 10) || 10,
        fallback: parseInt(wrapper.dataset.sliderFallback, 10) || 200,
        step: parseInt(wrapper.dataset.sliderStep, 10) || 1
      });
    });

    // Keep the original defaults for sliders without a valid data contract.
    LEGACY.forEach(function (config) {
      scope.querySelectorAll(config.wrapper).forEach(function (wrapper) {
        initSlider(wrapper, config);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Sliders rendered later by FightBase loaders.
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  window.f2wInitSliders = initAll;
})();

(function () {
  if (customElements.get('f2w-stock-highlights')) return;
  customElements.define('f2w-stock-highlights', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.optionAdapterBound === 'true') return;
      this.dataset.optionAdapterBound = 'true';
      this.addEventListener('click', function (event) {
        var button = event.target.closest('.cib__variant-btn');
        if (!button || !this.contains(button) || button.disabled) return;
        var card = button.closest('.cib__ref-card');
        if (!card || !button.dataset.variantId) return;
        var add = card.querySelector('.cib__atc-btn[data-variant-id]');
        if (!add || add.disabled) return;
        event.preventDefault();
        // Only variant selection is handled here. Cart clicks retain f2w-atc.js.
        // Stop the legacy async price fetch so rapid selection cannot race it.
        event.stopImmediatePropagation();
        card.querySelectorAll('.cib__variant-btn').forEach(function (option) {
          var selected = option === button;
          option.classList.toggle('is-selected', selected);
          option.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        add.dataset.variantId = button.dataset.variantId;
        var price = card.querySelector('[data-highlight-amount]');
        if (price) price.textContent = button.dataset.priceText || '';
        var compare = card.querySelector('[data-highlight-compare]');
        if (compare) {
          compare.textContent = button.dataset.compareText || '';
          compare.hidden = !button.dataset.compareText;
        }
        var link = card.querySelector('[data-highlight-link]');
        if (link && button.dataset.variantUrl) link.setAttribute('href', button.dataset.variantUrl);
      }, true);
    }
  });
})();

(function () {
  if (window.__f2wQuickAddBound) return;
  window.__f2wQuickAddBound = true;

  function qaMoney(cents) {
    if (window.Shopify && Shopify.formatMoney && window.f2w_money_format) {
      return Shopify.formatMoney(cents, window.f2w_money_format);
    }
    return (cents / 100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function qaValueSort(a, b) {
    var na = parseFloat(a);
    var nb = parseFloat(b);
    if (!isNaN(na) && !isNaN(nb) && String(na) === a.split(' ')[0] && String(nb) === b.split(' ')[0]) return na - nb;
    if (!isNaN(na) && !isNaN(nb) && na !== nb) return na - nb;
    return String(a).localeCompare(String(b), 'nl');
  }

  function qaCurrent(overlay) {
    var data = overlay.__qaData;
    var sel = overlay.__qaSel;
    if (!data || !sel) return null;
    for (var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i];
      var match = true;
      for (var j = 0; j < v.o.length; j++) {
        if (sel[j] !== undefined && v.o[j] !== sel[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function qaEnabled(overlay, optionIndex) {
    var data = overlay.__qaData;
    var sel = overlay.__qaSel;
    var enabled = {};
    data.variants.forEach(function (v) {
      if (!v.e) return;
      var ok = true;
      for (var j = 0; j < v.o.length; j++) {
        if (j !== optionIndex && sel[j] !== undefined && v.o[j] !== sel[j]) { ok = false; break; }
      }
      if (ok) enabled[v.o[optionIndex]] = true;
    });
    return enabled;
  }

  function qaResolveGroup(overlay, group) {
    var optionIndex = parseInt(group.dataset.f2wQaGroup, 10);
    var sel = overlay.__qaSel;
    var enabled = qaEnabled(overlay, optionIndex);
    if (sel[optionIndex] !== undefined && enabled[sel[optionIndex]]) return;
    var next = null;
    group.querySelectorAll('[data-f2w-qa-option]').forEach(function (button) {
      if (!next && enabled[button.dataset.f2wQaOption]) next = button;
    });
    sel[optionIndex] = next ? next.dataset.f2wQaOption : undefined;
  }

  function qaNormalise(overlay, changedIndex) {
    var groups = overlay.querySelectorAll('[data-f2w-qa-group]');
    groups.forEach(function (group) {
      if (parseInt(group.dataset.f2wQaGroup, 10) === changedIndex) return;
      qaResolveGroup(overlay, group);
    });
    var variant = qaCurrent(overlay);
    if (variant && variant.e) return;
    groups.forEach(function (group) { qaResolveGroup(overlay, group); });
  }

  function qaSync(overlay) {
    var data = overlay.__qaData;
    var sel = overlay.__qaSel;
    overlay.querySelectorAll('[data-f2w-qa-group]').forEach(function (group) {
      var optionIndex = parseInt(group.dataset.f2wQaGroup, 10);
      var enabled = qaEnabled(overlay, optionIndex);
      group.querySelectorAll('[data-f2w-qa-option]').forEach(function (button) {
        var value = button.dataset.f2wQaOption;
        var selected = value === sel[optionIndex];
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
        var available = enabled[value] === true;
        button.disabled = !available;
        button.classList.toggle('is-unavailable', !available);
      });
      var label = group.querySelector('[data-f2w-qa-value]');
      if (label) label.textContent = sel[optionIndex] || '';
    });
    var variant = qaCurrent(overlay);
    var amount = overlay.querySelector('[data-f2w-qa-amount]');
    var compare = overlay.querySelector('[data-f2w-qa-compare]');
    var chosen = overlay.querySelector('[data-f2w-qa-chosen]');
    var photo = overlay.querySelector('[data-f2w-qa-photo]');
    var view = overlay.querySelector('[data-f2w-qa-view]');
    var add = overlay.querySelector('[data-f2w-qa-add]');
    if (variant && variant.e) {
      if (amount) amount.textContent = qaMoney(variant.p);
      if (compare) {
        compare.textContent = variant.c ? qaMoney(variant.c) : '';
        compare.hidden = !variant.c;
      }
      if (chosen) chosen.textContent = variant.o.join(' / ');
      if (photo) {
        if (variant.i) {
          var img = photo.querySelector('img');
          if (!img) {
            img = document.createElement('img');
            img.setAttribute('alt', '');
            img.setAttribute('loading', 'lazy');
            photo.appendChild(img);
          }
          if (img.getAttribute('src') !== variant.i) img.src = variant.i;
          photo.hidden = false;
        } else {
          photo.hidden = true;
        }
      }
      if (view) view.href = variant.u;
      add.disabled = false;
    } else {
      add.disabled = true;
    }
    var total = overlay.querySelector('[data-f2w-qa-total]');
    if (total && variant && variant.e) total.textContent = qaMoney(variant.p * qaQuantity(overlay));
  }

  function qaQuantity(overlay) {
    var input = overlay.querySelector('[data-f2w-qa-qty]');
    var value = parseInt(input && input.value, 10);
    if (isNaN(value) || value < 1) return 1;
    return Math.min(value, 99);
  }

  function qaOpen(overlay, data) {
    overlay.__qaData = data;
    var initial = null;
    for (var i = 0; i < data.variants.length; i++) {
      if (data.variants[i].id === data.initial) { initial = data.variants[i]; break; }
    }
    if (!initial) {
      for (var j = 0; j < data.variants.length; j++) {
        if (data.variants[j].e) { initial = data.variants[j]; break; }
      }
    }
    overlay.__qaSel = initial ? initial.o.slice() : [];
    var title = overlay.querySelector('[data-f2w-qa-title]');
    if (title) title.textContent = data.title;
    var dialog = overlay.querySelector('.f2w-v2-picker__dialog');
    if (dialog) dialog.setAttribute('aria-label', data.title);
    var groups = overlay.querySelector('[data-f2w-qa-groups]');
    groups.innerHTML = '';
    data.options.forEach(function (name, index) {
      var seen = {};
      var values = [];
      data.variants.forEach(function (v) {
        var val = v.o[index];
        if (val !== undefined && !seen[val]) { seen[val] = true; values.push(val); }
      });
      values.sort(qaValueSort);
      var fieldset = document.createElement('fieldset');
      fieldset.className = 'f2w-v2-picker__group';
      fieldset.dataset.f2wQaGroup = String(index);
      var legend = document.createElement('legend');
      legend.className = 'f2w-v2-picker__legend';
      legend.appendChild(document.createTextNode(name + ': '));
      var span = document.createElement('span');
      span.setAttribute('data-f2w-qa-value', '');
      legend.appendChild(span);
      fieldset.appendChild(legend);
      var wrap = document.createElement('div');
      wrap.className = 'f2w-v2-picker__values';
      values.forEach(function (val) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'f2w-v2-picker__value';
        button.dataset.f2wQaOption = val;
        button.setAttribute('aria-pressed', 'false');
        button.textContent = val;
        wrap.appendChild(button);
      });
      fieldset.appendChild(wrap);
      groups.appendChild(fieldset);
    });
    var qty = overlay.querySelector('[data-f2w-qa-qty]');
    if (qty) qty.value = '1';
    overlay.hidden = false;
    overlay.__qaPrevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    qaSync(overlay);
    var first = overlay.querySelector('.f2w-v2-picker__value.is-selected') || overlay.querySelector('[data-f2w-qa-add]');
    if (first) first.focus();
  }

  function qaClose(overlay) {
    overlay.hidden = true;
    document.documentElement.style.overflow = overlay.__qaPrevOverflow || '';
  }

  document.addEventListener('click', function (event) {
    var openBtn = event.target && event.target.closest ? event.target.closest('[data-f2w-qa-open]') : null;
    if (openBtn) {
      var section = openBtn.closest('.shopify-section');
      if (!section) return;
      var overlay = section.querySelector('[data-f2w-qa-overlay]');
      var card = openBtn.closest('li');
      var island = card ? card.querySelector('[data-f2w-qa-data]') : null;
      if (!overlay || !island) return;
      var data = null;
      try { data = JSON.parse(island.textContent); } catch (error) { data = null; }
      if (!data || !data.variants || !data.variants.length) return;
      event.preventDefault();
      qaOpen(overlay, data);
      return;
    }
    var overlay = event.target && event.target.closest ? event.target.closest('[data-f2w-qa-overlay]') : null;
    if (!overlay || overlay.hidden) return;
    if (event.target === overlay) { qaClose(overlay); return; }
    if (event.target.closest('[data-f2w-qa-close]')) { qaClose(overlay); return; }
    var optionBtn = event.target.closest('[data-f2w-qa-option]');
    if (optionBtn && !optionBtn.disabled) {
      var group = optionBtn.closest('[data-f2w-qa-group]');
      var optionIndex = parseInt(group.dataset.f2wQaGroup, 10);
      overlay.__qaSel[optionIndex] = optionBtn.dataset.f2wQaOption;
      qaNormalise(overlay, optionIndex);
      qaSync(overlay);
      return;
    }
    if (event.target.closest('[data-f2w-qa-minus]')) {
      var qi = overlay.querySelector('[data-f2w-qa-qty]');
      if (qi) qi.value = String(Math.max(1, qaQuantity(overlay) - 1));
      qaSync(overlay);
      return;
    }
    if (event.target.closest('[data-f2w-qa-plus]')) {
      var qi2 = overlay.querySelector('[data-f2w-qa-qty]');
      if (qi2) qi2.value = String(Math.min(99, qaQuantity(overlay) + 1));
      qaSync(overlay);
      return;
    }
    if (event.target.closest('[data-f2w-qa-add]')) {
      var addBtn = overlay.querySelector('[data-f2w-qa-add]');
      var variant = qaCurrent(overlay);
      if (!variant || !variant.e || addBtn.disabled) return;
      addBtn.disabled = true;
      addBtn.setAttribute('aria-busy', 'true');
      var restore = function () {
        addBtn.disabled = false;
        addBtn.removeAttribute('aria-busy');
      };
      var timer = setTimeout(restore, 8000);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: variant.id, quantity: qaQuantity(overlay) }] })
      }).then(function (response) {
        if (!response.ok) throw new Error('Cart add failed');
        return response.json();
      }).then(function () {
        clearTimeout(timer);
        restore();
        qaClose(overlay);
        setTimeout(function () {
          if (window.opusRefresh) window.opusRefresh();
          if (window.opusOpen) {
            window.opusOpen();
          } else {
            document.documentElement.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
          }
        }, 150);
      }).catch(function () {
        clearTimeout(timer);
        restore();
        window.location.assign(variant.u);
      });
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target && event.target.closest ? event.target.closest('[data-f2w-qa-qty]') : null;
    if (!input) return;
    var overlay = input.closest('[data-f2w-qa-overlay]');
    if (!overlay) return;
    input.value = String(qaQuantity(overlay));
    qaSync(overlay);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-f2w-qa-overlay]').forEach(function (overlay) {
      if (!overlay.hidden) qaClose(overlay);
    });
  });

  document.addEventListener('touchstart', function (event) {
    var dialog = event.target && event.target.closest ? event.target.closest('.f2w-v2-picker__dialog') : null;
    if (!dialog) return;
    var overlay = dialog.closest('[data-f2w-qa-overlay]');
    if (!overlay || overlay.hidden || event.touches.length !== 1) return;
    overlay.__qaTouch = { y: event.touches[0].clientY, delta: 0, dragging: false };
  }, { passive: true });

  document.addEventListener('touchmove', function (event) {
    var dialog = event.target && event.target.closest ? event.target.closest('.f2w-v2-picker__dialog') : null;
    if (!dialog) return;
    var overlay = dialog.closest('[data-f2w-qa-overlay]');
    var touch = overlay && overlay.__qaTouch;
    if (!touch) return;
    touch.delta = event.touches[0].clientY - touch.y;
    if (!touch.dragging) {
      var onHeader = event.target.closest('.f2w-v2-picker__header') !== null;
      if (touch.delta > 12 && (onHeader || dialog.scrollTop <= 0)) {
        touch.dragging = true;
        dialog.style.transition = 'none';
      } else if (touch.delta < -12) {
        overlay.__qaTouch = null;
        return;
      } else {
        return;
      }
    }
    event.preventDefault();
    dialog.style.transform = 'translateY(' + Math.max(0, touch.delta) + 'px)';
  }, { passive: false });

  document.addEventListener('touchend', function (event) {
    var dialog = event.target && event.target.closest ? event.target.closest('.f2w-v2-picker__dialog') : null;
    if (!dialog) return;
    var overlay = dialog.closest('[data-f2w-qa-overlay]');
    var touch = overlay && overlay.__qaTouch;
    overlay.__qaTouch = null;
    if (!touch || !touch.dragging) return;
    dialog.style.transition = 'transform .2s ease-out';
    if (touch.delta > 90) {
      dialog.style.transform = 'translateY(100%)';
      setTimeout(function () {
        dialog.style.transform = '';
        dialog.style.transition = '';
        qaClose(overlay);
      }, 180);
    } else {
      dialog.style.transform = '';
      setTimeout(function () { dialog.style.transition = ''; }, 200);
    }
  });
})();

(function () {
  if (window.__f2wGroupCardsBound) return;
  window.__f2wGroupCardsBound = true;

  function f2wGrpMoney(cents) {
    if (window.Shopify && Shopify.formatMoney && window.f2w_money_format) {
      return Shopify.formatMoney(cents, window.f2w_money_format);
    }
    return (cents / 100).toLocaleString('nl-NL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function f2wGrpEsc(value) {
    var holder = document.createElement('div');
    holder.textContent = value == null ? '' : String(value);
    return holder.innerHTML;
  }

  document.addEventListener('click', function (event) {
    var thumb = event.target && event.target.closest ? event.target.closest('[data-f2w-grp-thumb], [data-f2w-sw-thumb]') : null;
    if (!thumb || thumb.disabled) return;
    var card = thumb.closest('.cib__ref-card');
    var island = card ? card.querySelector('[data-f2w-grp-data], [data-f2w-sw-data]') : null;
    if (!card || !island) return;
    event.preventDefault();
    var data = null;
    try { data = JSON.parse(island.textContent); } catch (error) { return; }
    var index = parseInt(thumb.dataset.f2wGrpThumb || thumb.dataset.f2wSwThumb, 10);
    var member = data.members && data.members[index];
    if (!member) return;
    // New V2 contract only. Existing Journal, legacy and native-colour islands
    // keep their original behaviour until explicitly migrated.
    var canonicalGroup = island.hasAttribute('data-f2w-canonical-group');
    if (canonicalGroup) {
      var canonicalTitle = card.querySelector('.cib__ref-card__title');
      if (canonicalTitle) canonicalTitle.textContent = member.t || '';
      var canonicalImage = card.querySelector('[data-highlight-link] img');
      if (canonicalImage) canonicalImage.hidden = !member.img;
      // The shared card creates this wrapper whenever any member has options.
      // A default-only product must not acquire a visible "Default Title" button.
    }
    card.querySelectorAll('[data-f2w-grp-thumb], [data-f2w-sw-thumb]').forEach(function (other) {
      var selected = other === thumb;
      other.classList.toggle('is-selected', selected);
      other.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    var link = card.querySelector('[data-highlight-link]');
    var image = link ? link.querySelector('img') : null;
    if (image && member.img) {
      image.src = member.img;
      image.srcset = (member.img360 || member.img) + ' 360w, ' + member.img + ' 720w';
      image.alt = member.t;
    }
    if (link) link.setAttribute('href', member.u);
    var view = card.querySelector('[data-f2w-grp-view]');
    if (view) view.setAttribute('href', member.u);
    var current = card.querySelector('.cib__variant-btn.is-selected');
    var keepLabel = current ? current.textContent.trim() : '';
    var wrap = card.querySelector('.cib__variant-btns');
    if (wrap) {
      var html = '';
      member.sizes.forEach(function (size) {
        if (canonicalGroup && member.hasOptions === false) return;
        if (size.av) {
          html += '<button type="button" class="cib__variant-btn" aria-pressed="false"'
            + ' data-variant-id="' + size.i + '"'
            + ' data-price-text="' + f2wGrpMoney(size.p) + '"'
            + ' data-compare-text="' + (size.c > size.p ? f2wGrpMoney(size.c) : '') + '"'
            + ' data-variant-url="' + size.u + '"'
            + '>' + f2wGrpEsc(size.l) + '</button>';
        } else if (data.su) {
          html += '<button type="button" class="cib__variant-btn is-unavailable" disabled aria-disabled="true" aria-pressed="false" title="' + f2wGrpEsc(data.ul || 'Niet beschikbaar') + '">' + f2wGrpEsc(size.l) + '</button>';
        }
      });
      wrap.innerHTML = html;
    }
    var next = null;
    var buttons = card.querySelectorAll('.cib__variant-btn:not([disabled])');
    buttons.forEach(function (button) { if (!next && button.textContent.trim() === keepLabel) next = button; });
    if (!next) next = buttons.length ? buttons[0] : null;
    var add = card.querySelector('.cib__atc-btn[data-variant-id]');
    if (!next && member.fv) {
      if (add) add.dataset.variantId = String(member.fv);
      var facePrice = card.querySelector('[data-highlight-amount]');
      if (facePrice) facePrice.textContent = member.fp != null ? f2wGrpMoney(member.fp) : '';
      var faceCompare = card.querySelector('[data-highlight-compare]');
      if (faceCompare) {
        var faceCompareText = member.fc != null && member.fc > member.fp ? f2wGrpMoney(member.fc) : '';
        faceCompare.textContent = faceCompareText;
        faceCompare.hidden = !faceCompareText;
      }
    } else if (next) {
      next.classList.add('is-selected');
      next.setAttribute('aria-pressed', 'true');
      if (add) add.dataset.variantId = next.dataset.variantId;
      var price = card.querySelector('[data-highlight-amount]');
      if (price) price.textContent = next.dataset.priceText || '';
      var compare = card.querySelector('[data-highlight-compare]');
      if (compare) {
        compare.textContent = next.dataset.compareText || '';
        compare.hidden = !next.dataset.compareText;
      }
    } else if (add) {
      add.dataset.variantId = '';
    }
    if (canonicalGroup) {
      var chosenId = next ? next.dataset.variantId : member.fv;
      var chosenVariant = (member.sizes || []).find(function (size) {
        return String(size.i) === String(chosenId) && size.av === true;
      });
      var canPurchase = !!chosenVariant;
      if (link && chosenVariant && chosenVariant.u) link.setAttribute('href', chosenVariant.u);
      if (add) {
        add.dataset.variantId = canPurchase ? String(chosenVariant.i) : '';
        add.disabled = !canPurchase;
        add.setAttribute('aria-disabled', canPurchase ? 'false' : 'true');
        if (canPurchase && data.addLabel) add.textContent = data.addLabel;
        if (!canPurchase && data.soldOutLabel) add.textContent = data.soldOutLabel;
      }
      card.classList.toggle('cib__ref-card--soldout', !canPurchase);
      var canonicalPrice = card.querySelector('[data-highlight-amount]');
      if (canonicalPrice && chosenVariant) {
        canonicalPrice.setAttribute('data-wpd-product-handle', member.handle || '');
        canonicalPrice.setAttribute('data-wpd-product-id', member.id || '');
        canonicalPrice.setAttribute('data-wpd-variant-id', chosenVariant.i);
        canonicalPrice.setAttribute('data-wpd-variant-price', chosenVariant.p);
        canonicalPrice.setAttribute('data-wpd-variant-compare-at-price', chosenVariant.c || '');
        canonicalPrice.setAttribute('data-wpd-product-collection-ids', member.collectionIds || '');
      }
      if (!canPurchase) {
        var unavailableFace = (member.sizes || [])[0];
        if (canonicalPrice && unavailableFace) canonicalPrice.textContent = f2wGrpMoney(unavailableFace.p);
        var unavailableCompare = card.querySelector('[data-highlight-compare]');
        if (unavailableCompare) {
          var compareValue = unavailableFace && unavailableFace.c > unavailableFace.p ? f2wGrpMoney(unavailableFace.c) : '';
          unavailableCompare.textContent = compareValue;
          unavailableCompare.hidden = !compareValue;
        }
      }
    }
  });

  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest ? event.target.closest('.cib__variant-btn') : null;
    if (!btn || btn.disabled) return;
    var card = btn.closest('.cib__ref-card');
    if (!card || !card.querySelector('.cib__group-thumbs')) return;
    event.preventDefault();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    card.querySelectorAll('.cib__variant-btn').forEach(function (other) {
      var selected = other === btn;
      other.classList.toggle('is-selected', selected);
      other.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    var add = card.querySelector('.cib__atc-btn[data-variant-id]');
    if (add) add.dataset.variantId = btn.dataset.variantId || '';
    var price = card.querySelector('[data-highlight-amount]');
    if (price) price.textContent = btn.dataset.priceText || '';
    var compare = card.querySelector('[data-highlight-compare]');
    if (compare) {
      compare.textContent = btn.dataset.compareText || '';
      compare.hidden = !btn.dataset.compareText;
    }
  }, true);
})();

